import { siteUrl } from '@/utils/siteUrl'

export const APP_STORE_URL = 'https://mysov.onelink.me/22NC/hvpznovs'
export const WEB_APP_URL = siteUrl('/home')

function getNavigator(): Navigator | undefined {
    return typeof navigator === 'undefined' ? undefined : navigator
}

export function isIOSDevice(nav = getNavigator()): boolean {
    if (!nav) return false

    const ua = nav.userAgent || ''
    return /iPhone|iPad|iPod/i.test(ua) || (/Macintosh/i.test(ua) && (nav.maxTouchPoints || 0) > 1)
}

export function isAndroidDevice(nav = getNavigator()): boolean {
    return /Android/i.test(nav?.userAgent || '')
}

export function isMobileDevice(nav = getNavigator()): boolean {
    if (!nav) return false

    const ua = nav.userAgent || ''
    return isIOSDevice(nav) || /Android|webOS|BlackBerry|IEMobile|Opera Mini/i.test(ua)
}

export function shouldUseAppStoreUrl(nav = getNavigator()): boolean {
    return isIOSDevice(nav) && isMobileDevice(nav)
}

export function getAppDownloadHref(): string {
    return shouldUseAppStoreUrl() ? APP_STORE_URL : WEB_APP_URL
}

export function openAppDownload(event?: Event): void {
    event?.preventDefault()
    if (typeof window === 'undefined') return

    window.location.href = getAppDownloadHref()
}
